<template>
  <div></div>
</template>

<script>
import axios from 'axios';

export default {
  methods: {
    checkToken() {
      axios
        .post(this.$store.getters.getApiUrl + '/api/refreshToken', {
          token: this.$store.getters.getToken
        })
        .then(response => {
          this.$store.commit('refreshToken', {
            token: response.data.token,
            loggedIn: true,
            currentUser: response.data.currentUser
          });
        })
        .catch(error => {
          console.log('Error!', error);
          this.$store.commit('refreshToken', {
            token: null,
            loggedIn: false,
            currentUser: ''
          });

          if (this.$store.getters.getIsAppState === true) {
            this.$store.commit('logout');
            this.$router.push({ path: '/mobile/app' });
          } else {
            this.$store.commit('logout');
            this.$router.push({ path: '/' });
          }
        });
    }
  },
  created: function() {
    this.checkToken();
  }
};
</script>
